// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDc1pxGP8cLRXPW0WNEgB04DgRF5OSt9ac",
  authDomain: "watchdogs-f7f36.firebaseapp.com",
  projectId: "watchdogs-f7f36",
  storageBucket: "watchdogs-f7f36.firebasestorage.app",
  messagingSenderId: "410007740417",
  appId: "1:410007740417:web:a7eb818e44129b8c3fe000"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

export default app; 